/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, PrintElem } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function Table2({ date, setOmbor }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const setSearch = (text) => {
    $("tbody tr.data-tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
      if (text != "") {
        $("tbody tr.j-tr").css("display", "none");
      } else {
        $("tbody tr.j-tr").css("display", "");
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/suvombor/table2?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => PrintElem(".table")}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <NavLink
              to={
                `${getEnv('REACT_APP_BASE_URL')}/export/mpdf?sana=` +
                date +
                "&table=suvombor2"
              }
              className='btn p-0'>
              <img src={pdf} alt='404' />
            </NavLink>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Suv omborlari jadval2", date, "so2")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead' id='tableFlexible'>
        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <table className='table table-bordered table-style' id='so2'>
            <thead>
              <tr>
                <th rowSpan={3} scope='col'>
                  N
                </th>

                <th rowSpan={3} scope='col'>
                  Suv Omborlar nomi
                </th>

                <th colSpan={4} scope='col'>
                  Hajmi (mln.m<sup>3</sup>)
                </th>

                <th rowSpan={2} scope='col'>
                  Kelishi, m<sup>3</sup>/sek
                </th>

                <th rowSpan={2} scope='col'>
                  Chiqishi, m<sup>3</sup>/sek
                </th>
              </tr>

              <tr>
                <th rowSpan={2} scope='col'>
                  Loyiha bo’yicha
                </th>

                <th rowSpan={2} scope='col'>
                  Ishlatib bo’lmaydi
                </th>

                <th colSpan={2} scope='col'>
                  Amalda
                </th>
              </tr>

              <tr>
                <th scope='col'>
                  {parseInt(date.slice(0, 4)) - 1}-{date.slice(5 - 10)}
                </th>
                <th scope='col'>{date}</th>
                <th scope='col'>{date}</th>
                <th scope='col'>{date}</th>
              </tr>
            </thead>

            <tbody></tbody>
            {data.length > 0
              ? data.map((d, index) => {
                  return (
                    <tbody key={index}>
                      <tr className='data-tr'>
                        <td>{index + 1}</td>
                        <td className='text-start fix-with'>
                          <NavLink
                            style={{
                              color: "#25213b",
                            }}
                            to={"/suvomborlari/" + d.id}
                            onClick={() =>
                              setOmbor({
                                nomi: d.nomi,
                                location: [d.lat, d.lan],
                              })
                            }>
                            {d.nomi}
                          </NavLink>
                        </td>
                        <td>{d.loyiha_boyicha}</td>
                        <td>{d.yaroqsiz}</td>
                        <td>{d.data1}</td>
                        <td>{d.data2}</td>
                        <td>{d.data3}</td>
                        <td>{d.data4}</td>
                      </tr>
                    </tbody>
                  );
                })
              : null}
          </table>
        )}
      </div>
    </>
  );
}

export default Table2;
